import React, {Component} from 'react';
import {Link, Switch, Route, Redirect} from 'react-router-dom'
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Login from '../../views/Pages/Login/Login';

import Dashboard from '../../views/Dashboard/';

import Charts from '../../views/Charts';

import EnsureLoggedInContainrer from '../../views/EnsureLoggedInContainer/EnsureLoggedInContainer'

import AllIslands from '../../views/IslandManagement/AllIslands/';
import AddUpdateIsland from '../../views/IslandManagement/AddUpdateIsland/';
import ExclusiveFeatures from '../../views/IslandManagement/ExclusiveFeatures/';
import AddCategory from '../../views/IslandManagement/AddCategory/';
import AllCategories from '../../views/IslandManagement/AllCategories/';
import ComingSoon from '../../views/IslandManagement/ComingSoon/';

import Homepage from '../../views/HauteManagement/HomePage/';
import SocialManagement from '../../views/HauteManagement/SocialManagement/';

import EnquiryDetails from '../../views/EnquiryDetails/';

import TestPage from '../../views/TestPage/';

import firebase from 'firebase';

class Full extends Component {
    constructor() {
        super();

        this.isAuth = true;
        this.state = {isAuth: true};
    }

    componentDidMount() {
        const _this = this;
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.isAuth = true;
                _this.setState({isAuth: true});
            }
            else {
                this.isAuth = false;
                _this.setState({isAuth: false});
            }
        })
    }

    render() {
        return (
            <div className="app">
                <Header />
                <div className="app-body">
                    <Sidebar {...this.props}/>
                    <main className="main">
                        <Breadcrumb />
                        <div className="container-fluid">

                            {/* <Route component={EnsureLoggedInContainrer}> */}

                            {this.isAuth ? (

                                <Switch>

                                    <Route path="/dashboard" name="Dashboard" component={Dashboard}/>

                                    <Route path="/charts" name="Charts" component={Charts}/>

                                    <Route exact path="/islands" name="Add Island" component={AllIslands}/>
                                    <Route exact path="/islands/addisland" name="Add Island"
                                           component={AddUpdateIsland}/>
                                    <Route path="/islands/addisland/:id" name="Add Island"
                                           component={AddUpdateIsland}/>
                                    <Route path="/islands/exclusivefeatures" name="Exclusive Features"
                                           component={ExclusiveFeatures}/>

                                    <Route path="/hautemngt/homepage" name="Home page" component={Homepage}/>
                                    <Route path="/hautemngt/socialmanagement" name="Social management"
                                           component={SocialManagement}/>

                                    <Route exact path="/categories/addcategory" name="Add Category"
                                           component={AddCategory}/>
                                    <Route path="/categories/addcategory/:id" name="Add Category"
                                           component={AddCategory}/>

                                    <Route exact path="/categories" name="All Categories"
                                           component={AllCategories}/>

                                    <Route path="/enquirydetails" name="Enquiry Details" component={EnquiryDetails}/>

                                    <Route path="/testpage" name="Test Page" component={TestPage}/>
                                    <Route path="/islands/comingsoon" name="Coming Soon" component={ComingSoon}/>

                                    <Redirect from="/" to="/dashboard"/>

                                </Switch>
                            )
                                : (<Redirect to="/login"/>)}


                            {/* </Route> */}

                        </div>
                    </main>
                    <Aside />
                </div>
                <Footer />
            </div>
        );
    }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js